import { Container } from "./Container"
import { TitleBox } from "./TitleBox"

export const Header = {
  Container,
  TitleBox,
}
